import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getUi } from '@ducks/ui/selectors';
import loadable from '@loadable/component';
import { PlanType } from '@/components/OurPlans/components/Plans/constants';
import useUser from '@/hooks/useUser';
import { useRewardful } from '@/hooks/useRewardful';
import { useUserAccess } from '@/hooks/useUserAccess';
import { useFlag } from '@/features/unleash';

const OnboardingModal = loadable(
  () => import('@/components/Onboarding/components/OnboardingModal'),
  {
    ssr: false,
  }
);

interface OnboardingProps {
  isRegistrationFromNews?: boolean;
}

function Onboarding({ isRegistrationFromNews }: OnboardingProps) {
  const ui = useSelector(getUi);
  const { data: user } = useUser();
  const { data: access } = useUserAccess();
  const { rewardful } = useRewardful();
  const flag = useFlag({ name: 'rewardful-metadata' });

  const showModal =
    (ui.showOnboarding &&
      user.loggedIn &&
      access.planType === PlanType.Premium &&
      user.billing.status === 'trialing' &&
      RUNTIME_ENV !== 'server') ||
    isRegistrationFromNews;

  useEffect(() => {
    if (!flag.flagsReady || flag.enabled) return;

    if (showModal && user.emailAddress) {
      // Expresses a state that the user has just registered and User data is available
      try {
        if (
          typeof rewardful !== 'undefined' &&
          typeof user.emailAddress !== 'undefined'
        ) {
          rewardful('convert', {
            email: user.emailAddress,
          });
        }
      } catch (err) {}
    }
  }, [flag.enabled, flag.flagsReady, rewardful, showModal, user.emailAddress]);

  if (!showModal) {
    return null;
  }

  return <OnboardingModal />;
}

export default Onboarding;
